import React, { FC } from "react";
import { defineMessages, useIntl } from "react-intl";
import BillingUpdatePaymentContainer from "@app/postBill/components/billingUpdatePaymentContainer";

import "./billingUpdatePayment.scss";

const messages = defineMessages({
  billingUpdatePaymentTitle: {
    id: "billingUpdatePaymentTitle",
    defaultMessage: "Update your payment method",
  },
});

const BillingUpdatePayment: FC = () => {
  const intl = useIntl();

  return (
    <div className="billing-update-payment">
      <div className="billing-update-payment__container">
        <h1 className="billing-update-payment__title">
          {intl.formatMessage(messages.billingUpdatePaymentTitle)}
        </h1>
        <div className="billing-update-payment__content">
          <BillingUpdatePaymentContainer />
        </div>
      </div>
    </div>
  );
};

export default BillingUpdatePayment;
